import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

const SIDE_IMG = "https://images.unsplash.com/photo-1659522761084-79196b64abe4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxmYXNoaW9uJTIwbW9kZWwlMjBlZGl0b3JpYWx8ZW58MHx8fHwxNzg2MzgzNDM1fDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bem-vinda de volta!");
      navigate(u.role === "admin" ? "/admin" : "/conta");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[calc(100vh-5rem)]">
      <div className="hidden lg:block relative">
        <img src={SIDE_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" />
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="overline text-[#B89C65] mb-3">Bem-vinda</div>
          <h1 className="font-serif text-4xl text-[#1A1A1A] mb-8">Entrar na conta</h1>
          <div className="space-y-5">
            <div>
              <label className="overline text-[#1A1A1A]/60 block mb-2">E-mail</label>
              <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className="w-full bg-transparent border-b border-[#1A1A1A]/20 focus:border-[#B89C65] outline-none py-3 transition-colors" />
            </div>
            <div>
              <label className="overline text-[#1A1A1A]/60 block mb-2">Senha</label>
              <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                className="w-full bg-transparent border-b border-[#1A1A1A]/20 focus:border-[#B89C65] outline-none py-3 transition-colors" />
            </div>
          </div>
          <button data-testid="login-submit" disabled={loading}
            className="w-full bg-[#1A1A1A] text-[#F8F7F4] py-4 mt-8 overline hover:bg-[#B89C65] transition-colors disabled:opacity-60">
            {loading ? "Entrando…" : "Entrar"}
          </button>
          <p className="text-center text-[#1A1A1A]/60 mt-6 text-sm">
            Não tem conta? <Link to="/cadastro" data-testid="go-register" className="text-[#B89C65] hover:underline">Cadastre-se</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
